// Este código registra el service worker para habilitar la funcionalidad de PWA.
// Por defecto en desarrollo local no se activa para evitar problemas con Hot Module Replacement (HMR) y refrescos obsoletos.
// En producción, carga automáticamente en segundo plano después de que la app se ha renderizado por completo.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] es la dirección IPv6 de localhost
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 son direcciones de bucle local para IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    // El constructor de URL está disponible en todos los navegadores modernos
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // El Service Worker no funcionará si PUBLIC_URL está en un origen diferente (ej. CDN)
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // En localhost, verificamos si el service worker actual sigue existiendo
        checkValidServiceWorker(swUrl, config);
        
        // Log descriptivo para desarrollo local si se desea testear PWA manualmente
        navigator.serviceWorker.ready.then(() => {
          console.log('[PWA] Esta aplicación está siendo servida en caché por un Service Worker.');
        });
      } else {
        // En producción (no localhost), simplemente registramos el service worker
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // El contenido nuevo ha sido precacheado, pero el anterior sigue activo en las pestañas abiertas.
              console.log('[PWA] Nueva versión disponible. Se aplicará al cerrar todas las pestañas de la app.');

              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // Todo ha sido precacheado exitosamente por primera vez.
              console.log('[PWA] La aplicación se ha cacheado para su uso offline.');

              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('[PWA] Error durante el registro del Service Worker:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  // Comprobamos si el service worker se puede encontrar. Si no, recargamos la página.
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // No se encontró el service worker. Probablemente una app diferente. Desregistrar y recargar.
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker válido encontrado. Proceder al registro.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('[PWA] No hay conexión a internet. La aplicación se está ejecutando en modo offline.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error('[PWA] Error al desregistrar el Service Worker:', error);
      });
  }
}
